import { CardContainer } from '@apps-common/components/common'
import { SectionTitle } from '@apps-common/components/common/portal-title'
import { ToggleInputSM } from '@apps-common/components/elements/form'
import { VertSpacerMd } from '@apps-common/components/layout'
import { ThemeSelector } from '@apps-common/components/theme'
import { AUTH_CLAIMS, Authorization } from '@apps-common/lib'
import { useThemeStore } from '@apps-common/stores'

export const ThemeSettings = () => {
  const { editing, toggleEditing } = useThemeStore()

  return (
    <CardContainer bgClasses='flex flex-col bg-surface border border-border md:px-5 md:py-4'>
      <div className='flex items-center justify-between'>
        <SectionTitle classes='text-text-muted/70 text-left pl-[10px]' text='Theme' />
      </div>
      <VertSpacerMd />
      <div className='grow text-text rounded-[30px] py-3 pr-3 sm:py-3 sm:pr-4'>
        <Authorization roles={AUTH_CLAIMS.managementAdmin.roles} scopes={AUTH_CLAIMS.managementAdmin.scopes}>
          <>
            <ToggleInputSM
              labelLeft='Theme editor'
              containerClassName='!mb-0'
              innerContainerClassName='!m-0 !px-0'
              disabled={false}
              registration={{
                checked: editing,
                onChange: (e: any) => toggleEditing()
              }}
            />
            <VertSpacerMd />
          </>
        </Authorization>
        <div className='flex items-center justify-between pl-[10px]'>
          <p className='text-[0.9em] sm:text-[1em]'>Theme mode</p>
          <ThemeSelector />
        </div>
      </div>
    </CardContainer>
  )
}
